import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import CurrencyCurrency from "@/models/Currency/Currency";

export default class Currency extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'agent/code/currency';

    /**
     *
     * @type {string}
     */
    static entity = 'agentCodeCurrencies';

    static fields() {
        return {
            id: this.number(null).nullable(),
            agent_code_id: this.number(null).nullable(),
            currency_id: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            currency: this.belongsTo(CurrencyCurrency, 'currency_id'),
            user: this.belongsTo(User, 'user_id'),
        }
    }

    /**
     *
     * @returns {boolean|*}
     */
    User() {
        return this.getRelated('user');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Agent() {
        return this.getRelated('agent');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Currency() {
        return this.getRelated('currency');
    }

}
